import { render } from "./ContactPage.vue?vue&type=template&id=4ded52f1"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__